import { render, staticRenderFns } from "./SearchTableMessages.vue?vue&type=template&id=9c46afc6&scoped=true&"
import script from "./SearchTableMessages.vue?vue&type=script&lang=js&"
export * from "./SearchTableMessages.vue?vue&type=script&lang=js&"
import style0 from "./SearchTableMessages.vue?vue&type=style&index=0&id=9c46afc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c46afc6",
  null
  
)

export default component.exports